/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Group_Page_DescInputs */

const vi_customer_group_page_desc = /** @type {(inputs: Customer_Group_Page_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cấu hình nhóm khách hàng và tỷ lệ chiết khấu`)
};

/**

* @param {Customer_Group_Page_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_group_page_desc = /** @type {((inputs?: Customer_Group_Page_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Group_Page_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_group_page_desc(inputs)
});